import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, Teleport as _Teleport, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "flex items-start justify-between gap-4 border-b border-slate-200 bg-slate-50 px-6 py-5"
};
const _hoisted_2 = {
  class: "flex min-w-0 items-center gap-3"
};
const _hoisted_3 = {
  class: "min-w-0"
};
const _hoisted_4 = {
  class: "truncate text-lg font-semibold leading-6 text-slate-900"
};
const _hoisted_5 = {
  key: 0,
  class: "mt-1 text-sm text-slate-500"
};
const _hoisted_6 = {
  class: "px-6 py-5"
};
const _hoisted_7 = {
  class: "flex flex-col-reverse gap-3 border-t border-slate-200 bg-slate-50 px-6 py-4 sm:flex-row sm:items-center sm:justify-end"
};
const _hoisted_8 = ["disabled"];
const _hoisted_9 = {
  key: 0
};
const _hoisted_10 = {
  key: 1
};
const _hoisted_11 = {
  class: "max-h-[320px] overflow-y-auto px-6 py-4"
};
const _hoisted_12 = {
  class: "min-w-0"
};
const _hoisted_13 = {
  class: "flex items-center gap-2"
};
const _hoisted_14 = {
  class: "truncate text-base font-semibold text-slate-900"
};
const _hoisted_15 = {
  key: 0,
  class: "status-badge is-danger shrink-0"
};
const _hoisted_16 = {
  class: "mt-1 flex flex-wrap gap-x-4 text-sm text-slate-500"
};
const _hoisted_17 = {
  class: "mt-0.5 text-xs text-slate-400"
};
const _hoisted_18 = ["onClick"];
import { ref, reactive, watch } from 'vue';
import { ElMessage } from 'element-plus';
import { createReferrer, updateReferrer, checkReferrerDuplicates } from '@/api/referrer';
import AppModal from '@/components/AppModal.vue';
export default {
  __name: 'ReferrerFormModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    referrerData: {
      type: Object,
      default: null
    }
  },
  emits: ['update:visible', 'success', 'select-existing'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const formRef = ref(null);
    const submitting = ref(false);

    // 重复引入人选择弹窗
    const duplicateDialogVisible = ref(false);
    const duplicateList = ref([]);

    // 格式化创建时间
    const formatCreateTime = time => {
      if (!time) return '-';
      return new Date(time).toLocaleString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      });
    };

    // 表单数据
    const formData = reactive({
      name: '',
      phone: '',
      wechat: '',
      referrerType: '',
      remark: ''
    });

    // 自定义验证器：手机号格式
    const validatePhone = (rule, value, callback) => {
      if (value && !/^1[3-9]\d{9}$|^0\d{2,3}-?\d{7,8}$/.test(value)) {
        callback(new Error('请输入正确的手机号码或电话号码'));
      } else {
        callback();
      }
    };

    // 表单验证规则
    const rules = {
      name: [{
        required: true,
        message: '请输入引入人姓名',
        trigger: 'blur'
      }, {
        min: 1,
        max: 50,
        message: '姓名长度不能超过50个字符',
        trigger: 'blur'
      }],
      phone: [{
        validator: validatePhone,
        trigger: 'blur'
      }],
      wechat: [{
        required: true,
        message: '请输入微信号',
        trigger: 'blur'
      }],
      referrerType: [{
        required: true,
        message: '请选择引入类型',
        trigger: 'change'
      }]
    };

    // 监听弹窗显示
    watch(() => props.visible, val => {
      if (val && props.referrerData) {
        // 编辑模式
        formData.id = props.referrerData.id;
        formData.name = props.referrerData.name || '';
        formData.phone = props.referrerData.phone || '';
        formData.wechat = props.referrerData.wechat || '';
        formData.referrerType = props.referrerData.referrerType || '';
        formData.remark = props.referrerData.remark || '';
      } else if (val) {
        // 新增模式
        formData.id = null;
        formData.name = '';
        formData.phone = '';
        formData.wechat = '';
        formData.referrerType = '';
        formData.remark = '';
      }
    });

    // 关闭弹窗
    const handleClose = () => {
      duplicateDialogVisible.value = false;
      emit('update:visible', false);
    };

    // 选择已有引入人
    const handleSelectDuplicate = item => {
      duplicateDialogVisible.value = false;
      emit('select-existing', item);
      handleClose();
    };

    // 返回重新编辑
    const handleReedit = () => {
      duplicateDialogVisible.value = false;
    };

    // 提交表单
    const handleSubmit = async () => {
      try {
        await formRef.value.validate();
        submitting.value = true;

        // 新增/编辑前先检查是否存在相同姓名、手机号或微信号的引入人
        const duplicates = await checkReferrerDuplicates({
          name: formData.name,
          phone: formData.phone,
          wechat: formData.wechat,
          excludeId: formData.id || null
        });
        if (duplicates && duplicates.length > 0) {
          duplicateList.value = duplicates;
          duplicateDialogVisible.value = true;
          return;
        }
        if (formData.id) {
          // 编辑
          const updatedReferrer = await updateReferrer({
            id: formData.id,
            name: formData.name,
            phone: formData.phone,
            wechat: formData.wechat,
            referrerType: formData.referrerType,
            remark: formData.remark
          });
          ElMessage.success('更新成功');
          emit('success', {
            action: 'update',
            referrer: updatedReferrer
          });
        } else {
          // 新增
          const createdReferrer = await createReferrer({
            name: formData.name,
            phone: formData.phone,
            wechat: formData.wechat,
            referrerType: formData.referrerType,
            remark: formData.remark
          });
          ElMessage.success('创建成功');
          emit('success', {
            action: 'create',
            referrer: createdReferrer
          });
        }
        handleClose();
      } catch (error) {
        console.error('保存引入人失败:', error);
        if (error !== false) {
          ElMessage.error(error.message || '保存失败');
        }
      } finally {
        submitting.value = false;
      }
    };
    return (_ctx, _cache) => {
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_form = _resolveComponent("el-form");
      return _openBlock(), _createBlock(_Teleport, {
        to: "body"
      }, [_createVNode(AppModal, {
        visible: __props.visible,
        size: "xl",
        onClose: handleClose
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[5] || (_cache[5] = _createElementVNode("div", {
          class: "flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-primary-50 text-primary-600 ring-1 ring-primary-100"
        }, [_createElementVNode("svg", {
          class: "h-5 w-5",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M18 18.72a9.094 9.094 0 003.75 1.03 1.5 1.5 0 001.5-1.5v-.621a4.5 4.5 0 00-2.548-4.055l-.253-.126a.75.75 0 00-.828.111l-1.253 1.253a.75.75 0 01-.91.113 7.5 7.5 0 01-3.383-3.383.75.75 0 01.113-.91l1.253-1.253a.75.75 0 00.111-.828l-.126-.253A4.5 4.5 0 0011.371 5.75h-.621a1.5 1.5 0 00-1.5 1.5 9.094 9.094 0 001.03 3.75"
        }), _createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M15 19.128A9.38 9.38 0 0112 19.5a9.5 9.5 0 119.5-9.5c0 1.02-.16 2.003-.456 2.925"
        })])], -1)), _createElementVNode("div", _hoisted_3, [_createElementVNode("h3", _hoisted_4, _toDisplayString(__props.referrerData?.id ? '编辑引入人' : '新增引入人'), 1), __props.referrerData?.id ? (_openBlock(), _createElementBlock("div", _hoisted_5, " ID " + _toDisplayString(__props.referrerData.id), 1)) : _createCommentVNode("", true)])]), _createElementVNode("button", {
          onClick: handleClose,
          type: "button",
          class: "inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-lg text-slate-400 transition-colors hover:bg-white hover:text-slate-700",
          title: "关闭"
        }, [...(_cache[6] || (_cache[6] = [_createElementVNode("svg", {
          class: "w-5 h-5",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M6 18L18 6M6 6l12 12"
        })], -1)]))])]), _createElementVNode("div", _hoisted_6, [_createVNode(_component_el_form, {
          ref_key: "formRef",
          ref: formRef,
          model: formData,
          rules: rules,
          "label-width": "100px",
          class: "space-y-1"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "姓名",
            prop: "name"
          }, {
            default: _withCtx(() => [_withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => formData.name = $event),
              type: "text",
              placeholder: "请输入引入人姓名",
              class: "form-input w-full"
            }, null, 512), [[_vModelText, formData.name]])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "联系电话",
            prop: "phone"
          }, {
            default: _withCtx(() => [_withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => formData.phone = $event),
              type: "text",
              placeholder: "请输入联系电话",
              class: "form-input w-full"
            }, null, 512), [[_vModelText, formData.phone]])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "微信号",
            prop: "wechat"
          }, {
            default: _withCtx(() => [_withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => formData.wechat = $event),
              type: "text",
              placeholder: "请输入微信号",
              class: "form-input w-full"
            }, null, 512), [[_vModelText, formData.wechat]])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "引入类型",
            prop: "referrerType"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: formData.referrerType,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => formData.referrerType = $event),
              placeholder: "请选择引入类型",
              class: "form-select w-full"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_option, {
                label: "渠道",
                value: "0"
              }), _createVNode(_component_el_option, {
                label: "客户转介绍",
                value: "1"
              }), _createVNode(_component_el_option, {
                label: "政府",
                value: "2"
              }), _createVNode(_component_el_option, {
                label: "其他",
                value: "3"
              })]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "备注"
          }, {
            default: _withCtx(() => [_withDirectives(_createElementVNode("textarea", {
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => formData.remark = $event),
              rows: "3",
              placeholder: "请输入备注（选填）",
              class: "form-textarea"
            }, null, 512), [[_vModelText, formData.remark]])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])]), _createElementVNode("div", _hoisted_7, [_createElementVNode("button", {
          onClick: handleClose,
          type: "button",
          class: "btn-secondary w-full sm:w-auto"
        }, " 取消 "), _createElementVNode("button", {
          onClick: handleSubmit,
          disabled: submitting.value,
          type: "button",
          class: "btn-primary w-full sm:w-auto"
        }, [submitting.value ? (_openBlock(), _createElementBlock("span", _hoisted_9, "保存中...")) : (_openBlock(), _createElementBlock("span", _hoisted_10, "保存"))], 8, _hoisted_8)])]),
        _: 1
      }, 8, ["visible"]), _createVNode(AppModal, {
        visible: duplicateDialogVisible.value,
        size: "lg",
        onClose: handleReedit
      }, {
        default: _withCtx(() => [_cache[7] || (_cache[7] = _createElementVNode("div", {
          class: "border-b border-slate-200 bg-slate-50 px-6 py-5"
        }, [_createElementVNode("h3", {
          class: "text-lg font-semibold leading-6 text-slate-900"
        }, "发现相同引入人"), _createElementVNode("div", {
          class: "mt-1 text-sm text-slate-500"
        }, " 系统中已存在相同姓名、手机号或微信号的引入人，可直接选择已有引入人，或返回重新编辑 ")], -1)), _createElementVNode("div", _hoisted_11, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(duplicateList.value, item => {
          return _openBlock(), _createElementBlock("div", {
            key: item.id,
            class: "mb-3 flex items-center justify-between gap-3 rounded-lg border border-slate-200 px-4 py-3 last:mb-0"
          }, [_createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createElementVNode("span", _hoisted_14, _toDisplayString(item.name), 1), item.status === 0 ? (_openBlock(), _createElementBlock("span", _hoisted_15, "禁用")) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_16, [_createElementVNode("span", null, "电话：" + _toDisplayString(item.phone || '-'), 1), _createElementVNode("span", null, "微信：" + _toDisplayString(item.wechat || '-'), 1)]), _createElementVNode("div", _hoisted_17, _toDisplayString(item.referrerTypeName || '-') + " · 创建于 " + _toDisplayString(formatCreateTime(item.createTime)), 1)]), _createElementVNode("button", {
            onClick: $event => handleSelectDuplicate(item),
            type: "button",
            class: "btn-primary shrink-0"
          }, " 选择该引入人 ", 8, _hoisted_18)]);
        }), 128))]), _createElementVNode("div", {
          class: "flex justify-end border-t border-slate-200 bg-slate-50 px-6 py-4"
        }, [_createElementVNode("button", {
          onClick: handleReedit,
          type: "button",
          class: "btn-secondary"
        }, " 重新编辑 ")])]),
        _: 1
      }, 8, ["visible"])]);
    };
  }
};